import React from 'react';
import { Button } from 'react-bootstrap';
import { MdFlashOn } from 'react-icons/md';

type ButtonProps = React.ComponentProps<typeof Button>;
//type ButtonProps = React.PropsWithoutRef<ComponentProps<typeof Button>>;

type Props = ButtonProps & {
  text: string;
};

const ButtonAction = ({
  text,
  variant = 'danger',
  onClick,
  ...rest
}: Props) => (
  <Button
    size="sm"
    style={{ minWidth: '240px' }}
    className="ms-2"
    variant={variant}
    onClick={onClick}
    {...rest}
  >
    <MdFlashOn className="mb-1" /> {` ${text}`}
  </Button>
);
export default React.memo(ButtonAction);
